export default "__VITE_ASSET__BcGTYtL7__"